// @flow
import Program from './Program';

const makeProgramFromApiResponse = (responseProgram: any): Program => new Program(responseProgram);

export default makeProgramFromApiResponse;
